import { render } from "./Editor.vue?vue&type=template&id=13bfe2ba"
import script from "./Editor.vue?vue&type=script&lang=js"
export * from "./Editor.vue?vue&type=script&lang=js"

import "./Editor.vue?vue&type=style&index=0&id=13bfe2ba&lang=css"
script.render = render

export default script